module.exports = __webpack_public_path__ + "img/IntelliBee-Logo1.ff098fac.png";